import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import Footer from '../sections/Footer';
import Navbar from '../sections/Navbar';
import emailjs from '@emailjs/browser';
import { message } from 'antd';
import SuccessModal from '../components/SuccessModal';

const CheckoutScreen = () => {
    const { cartItems, clearCart } = useCart();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        phone: '',
        fullName: '',
        address: '',
        city: '',
        zip: '',
        state: '',
    });
    const [isProcessing, setIsProcessing] = useState(false);
    const [selectedShipping, setSelectedShipping] = useState('standard');
    const [successModal, setSuccessModal] = useState({ open: false, message: '' });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prevData => ({ ...prevData, [id]: value }));
    };

    const shippingOptions = {
        standard: { label: 'Standard Shipping (6-9 Days)', price: 0 },
        expedited: { label: 'Expedited Shipping (2-4 Days)', price: 40 },
    };

    const subtotal = cartItems.reduce((total, item) => total + parseFloat(item.price || 0) * item.quantity, 0);
    const shippingCost = shippingOptions[selectedShipping].price;
    const total = subtotal + shippingCost;

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsProcessing(true);
        
        // --- 1. Prepare all data for the email template ---
        const orderItemsHTML = cartItems.map(item => 
            `<p>${item.name} (x${item.quantity}) - <strong>${(parseFloat(item.price) * item.quantity).toFixed(2)} Dh</strong></p>`
        ).join('');
        
        const templateParams = {
            order_id: `ORD-${Date.now()}`,
            customer_name: formData.fullName,
            customer_phone: formData.phone,
            shipping_address: formData.address,
            shipping_city: formData.city,
            shipping_state: formData.state,
            shipping_zip: formData.zip,
            order_items: orderItemsHTML,
            shipping_method: shippingOptions[selectedShipping].label,
            subtotal: `${subtotal.toFixed(2)} Dh`,
            shipping_cost: shippingCost === 0 ? 'Free' : `${shippingCost.toFixed(2)} Dh`,
            total_price: `${total.toFixed(2)} Dh`,
        };

        // --- 2. Your EmailJS credentials ---
        const serviceID = 'service_sb61i9y';
        const templateID = 'template_c58qczb';
        const publicKey = '_MAPT6u2x17ZgW8Tf';

        // --- 3. Send the email ---
        emailjs.send(serviceID, templateID, templateParams, publicKey)
            .then((result) => {
                console.log('EmailJS Success:', result.text);
                setSuccessModal({ 
                    open: true, 
                    message: 'Your order has been placed successfully!' 
                });
                clearCart(); // Clear the cart on success
            }, (error) => {
                console.error('EmailJS Error:', error.text);
                message.error('There was a problem submitting your order. Please try again.');
            })
            .finally(() => {
                setIsProcessing(false);
            });
    };

  

  return (
    <>
       <form className="checkout-page-container" onSubmit={handleSubmit}>
      <div className="checkout-page-container">
        {/* Left Side: Order Summary */}
        <div className="order-summary-side">
          <button onClick={() => navigate(-1)} className="back-button-check">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>
            Back
          </button>
          
          <div className="summary-content">
            <h1 className="summary-title">Pay Grams Coffee.</h1>
            <div className="summary-main-total">{total.toFixed(2)} Dh</div>
            
            <div className="summary-items-list">
              {cartItems.map(item => (
                <div key={item.id} className="summary-item">
                  <div className="item-image-container">
                    <img src={item.image} alt={item.name} />
                    <span className="item-quantity">{item.quantity}</span>
                  </div>
                  <div className="summary-item-info">
                    <p>{item.name}</p>
                    <p>Qty: {item.quantity}</p>
                  </div>
                  <p className="summary-item-price">{(parseFloat(item.price) * item.quantity).toFixed(2)} Dh</p>
                </div>
              ))}
            </div>

            <div className="summary-breakdown">
              <div className="breakdown-row">
                <span>Subtotal</span>
                <span>{subtotal.toFixed(2)} Dh</span>
              </div>
              <div className="breakdown-row">
                <span>Shipping</span>
                <span>{shippingCost === 0 ? 'Free' : `${shippingCost.toFixed(2)} Dh`}</span>
              </div>
              <div className="breakdown-divider"></div>
              <div className="breakdown-row total">
                <span>Total</span>
                <span>{total.toFixed(2)} Dh</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Shipping and Payment */}
        <div className="shipping-side">
            <div className="form-section">
              <h2 className="form-section-title">Shipping informations</h2>
              <div className="form-group">
                <label htmlFor="phone">Phone number</label>
                <input type="tel" id="phone" placeholder="Phone number" value={formData.phone} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="fullName">Shipping Address</label>
                <input type="text" id="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
                <input type="text" id="address" placeholder="Street Address" className="mt-1" value={formData.address} onChange={handleChange} required />
                <div className="input-row mt-1">
                  <input type="text" id="city" placeholder="City" value={formData.city} onChange={handleChange} required />
                  
                </div>
                
              </div>
            </div>
            <div className="form-section">
              <h2 className="form-section-title">Shipping Method</h2>
              <div className="radio-group">
                  {Object.keys(shippingOptions).map(key => (
                      <div key={key} className="radio-option">
                          <input type="radio" id={key} name="shipping" value={key} checked={selectedShipping === key} onChange={(e) => setSelectedShipping(e.target.value)} />
                          <label htmlFor={key}>
                              <span className="radio-label-text">{shippingOptions[key].label}</span>
                              <span className="radio-label-price">{shippingOptions[key].price === 0 ? 'Free' : `${shippingOptions[key].price.toFixed(2)} DH`}</span>
                          </label>
                      </div>
                  ))}
              </div>
          </div>
            <div className="form-section">
              <h2 className="form-section-title">Payment Method</h2>
              <div className="radio-group">
                <div className="radio-option">
                   <input type="radio" id="cash" name="payment" value="cash" defaultChecked/>
                   <label htmlFor="cash">Pay in Cash</label>
                </div>
              </div>
            </div>

            <button type="submit" className="pay-btn" disabled={isProcessing}>
          {isProcessing ? 'Processing...' : 'Pay'}
            </button>
            <p className="terms-text">
              By confirming your payment, you allow Grams Coffee. LLC to charge you for this payment and future payments in accordance with their terms. By placing your order, you agree to our Terms of Service and Privacy Policy.
            </p>
    
        </div>
        </div>
      </form>
        <SuccessModal
                open={successModal.open}
                message={successModal.message}
                onClose={() => {
                    setSuccessModal({ open: false, message: '' });
                    navigate('/');
                }}
            />
      <Footer />
    </>
  );
};

export default CheckoutScreen;